import React from 'react';
import { Link } from 'react-router-dom';
const LOGO = 'https://cdn.magicpatterns.com/uploads/aK4zN9dM4nFr9UEPSqRepA/beautybewust-logo-menu-300x140.jpg';
export function Logo({
  className = 'h-11'
}: {
  className?: string;
}) {
  return <Link to="/" aria-label="Beauty Bewust — naar de homepage" className="inline-flex shrink-0 items-center transition-opacity duration-150 ease-soft hover:opacity-75" data-id="element-211" data-mp="3qb5xitv3uvmv">
      <img src={LOGO} alt="Beauty Bewust" className={`${className} w-auto mix-blend-multiply`} data-id="element-212" data-mp="mtdy4uen39en" />
    </Link>;
}